import { handleAddMailToInvite, handleRemoveEmailInvite, handleInviteViaEmail } from './handlers';

export function initAmbassador() {
	handleAddMailToInvite();
	handleRemoveEmailInvite();
	handleInviteViaEmail();
}
